import React, { useState } from 'react';
import '../styles/Contact.css';

const Contact = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        company: '',
        subject: '',
        message: ''
    });

    const handleInputChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log('Form submitted:', formData);
        alert('Thank you for your message! We will get back to you soon.');
    };

    const offices = [
        // {
        //     city: 'Mumbai',
        //     address: 'MapLube House, Andheri East, Mumbai - 400069',
        //     phone: '+91 22 1234 5678',
        //     email: 'mumbai@maplube.com',
        //     hours: 'Mon-Fri: 9:00 AM - 6:00 PM'
        // },
        {
            city: 'Delhi',
            address: '10130A, 10th Floor, Gaur City Mall Sector 4, Greater Noida-201318',
            phone: '+91 9540 071804',
            email: 'contact@maplube.in',
            hours: 'Mon-Fri: 9:00 AM - 6:00 PM'
        },
        // {
        //     city: 'Bangalore',
        //     address: 'MapLube Plaza, MG Road, Bangalore - 560001',
        //     phone: '+91 80 3456 7890',
        //     email: 'bangalore@maplube.com',
        //     hours: 'Mon-Fri: 9:00 AM - 6:00 PM'
        // }
    ];

    const departments = [
        {
            name: 'Sales',
            phone: '+91 95400 71804',
            email: 'sales@maplube.in',
            description: 'For product inquiries and sales support'
        },
        {
            name: 'Technical Support',
            phone: '+91 95400 71804',
            email: 'support@maplube.in',
            description: 'For technical assistance and product guidance'
        },
        {
            name: 'Customer Service',
            phone: '+91 95400 71804',
            email: 'support@maplube.in',
            description: 'For general inquiries and customer support'
        },
        {
            name: 'Dealership',
            phone: '+91 95400 71804',
            email: 'contact@maplube.in',
            description: 'For dealership and partnership inquiries'
        }
    ];

    return (
        <div className="contact">
            {/* Hero Section */}
            <section className="contact-hero">
                <div className="container">
                    <div className="contact-hero-content">
                        <h1>Contact Us</h1>
                        <p>Get in touch with our team for any inquiries, support, or partnership opportunities</p>
                    </div>
                </div>
            </section>

            {/* Contact Form & Info */}
            <section className="contact-main">
                <div className="container">
                    <div className="contact-content">
                        <div className="contact-form-section">
                            <h2>Send us a Message</h2>
                            <p>Fill out the form below and we'll get back to you within 24 hours.</p>
                            <form onSubmit={handleSubmit} className="contact-form">
                                <div className="form-row">
                                    <div className="form-group">
                                        <label htmlFor="name">Full Name *</label>
                                        <input
                                            type="text"
                                            id="name"
                                            name="name"
                                            value={formData.name}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="email">Email Address *</label>
                                        <input
                                            type="email"
                                            id="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                </div>
                                <div className="form-row">
                                    <div className="form-group">
                                        <label htmlFor="phone">Phone Number</label>
                                        <input
                                            type="tel"
                                            id="phone"
                                            name="phone"
                                            value={formData.phone}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="company">Company</label>
                                        <input
                                            type="text"
                                            id="company"
                                            name="company"
                                            value={formData.company}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="subject">Subject *</label>
                                    <select
                                        id="subject"
                                        name="subject"
                                        value={formData.subject}
                                        onChange={handleInputChange}
                                        required
                                    >
                                        <option value="">Select a subject</option>
                                        <option value="product-inquiry">Product Inquiry</option>
                                        <option value="technical-support">Technical Support</option>
                                        <option value="dealership">Dealership Inquiry</option>
                                        <option value="bulk-order">Bulk Order</option>
                                        <option value="general">General Inquiry</option>
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="message">Message *</label>
                                    <textarea
                                        id="message"
                                        name="message"
                                        value={formData.message}
                                        onChange={handleInputChange}
                                        rows="5"
                                        required
                                        placeholder="Tell us how we can help you..."
                                    ></textarea>
                                </div>
                                <button type="submit" className="btn btn-primary">Send Message</button>
                            </form>
                        </div>
                        <div className="contact-info-section">
                            <h2>Get in Touch</h2>
                            <div className="contact-methods">
                                <div className="contact-method">
                                    <div className="method-icon">📞</div>
                                    <div>
                                        <h3>Call Us</h3>
                                        <p>+91 9540 071804</p>
                                        <span>Available Mon-Fri, 9:00 AM - 6:00 PM</span>
                                    </div>
                                </div>
                                <div className="contact-method">
                                    <div className="method-icon">✉️</div>
                                    <div>
                                        <h3>Email Us</h3>
                                        <p>contact@maplube.in</p>
                                        <span>We'll respond within 24 hours</span>
                                    </div>
                                </div>
                                <div className="contact-method">
                                    <div className="method-icon">📍</div>
                                    <div>
                                        <h3>Visit Us</h3>
                                        <p>10130A, 10th Floor, Gaur City Mall</p>
                                        <span>Sector 4, Greater Noida-201318, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Office Locations */}
            <section className="office-locations">
                <div className="container">
                    <h2>Our Office Locations</h2>
                    <div className="offices-grid">
                        {offices.map((office, index) => (
                            <div key={index} className="office-card">
                                <h3>{office.city}</h3>
                                <div className="office-details">
                                    <div className="office-item">
                                        <span className="item-label">Address:</span>
                                        <p>{office.address}</p>
                                    </div>
                                    <div className="office-item">
                                        <span className="item-label">Phone:</span>
                                        <p>{office.phone}</p>
                                    </div>
                                    <div className="office-item">
                                        <span className="item-label">Email:</span>
                                        <p>{office.email}</p>
                                    </div>
                                    <div className="office-item">
                                        <span className="item-label">Hours:</span>
                                        <p>{office.hours}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Departments */}
            <section className="departments">
                <div className="container">
                    <h2>Contact by Department</h2>
                    <div className="departments-grid">
                        {departments.map((dept, index) => (
                            <div key={index} className="department-card">
                                <h3>{dept.name}</h3>
                                <p className="dept-description">{dept.description}</p>
                                <div className="dept-contact">
                                    <div className="dept-item">
                                        <span className="item-label">Phone:</span>
                                        <p>{dept.phone}</p>
                                    </div>
                                    <div className="dept-item">
                                        <span className="item-label">Email:</span>
                                        <p>{dept.email}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Map Section */}
            <section className="map-section">
                <div className="container">
                    <h2>Find Us</h2>
                    <div className="map-container">
                        <div className="map-placeholder">
                            <div className="map-icon">🗺️</div>
                            <h3>Interactive Map</h3>
                            <p>Our office locations across India</p>
                            <button className="btn btn-outline">View Full Map</button>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Contact;
